import { makePayment, verifyPayment } from './payment';

const API_BASE = 'https://3bxxzlknl8.execute-api.us-east-1.amazonaws.com/prod';

const testUser = {
  id: 'test-user-001',
  name: 'PUMPEDPay Tester',
  email: 'test@pumpedng.org',
  phone: '08000000000',
};

export const runTestPayment = async (amount = 1000) => {
  console.log('🚀 Starting test payment...');
  try {
    const result = await makePayment(testUser, amount);
    console.log('✅ Payment successful:', result);
    return result;
  } catch (error) {
    console.error('❌ Payment failed:', error);
    return error;
  }
};

export const runHealthCheck = async () => {
  try {
    const res = await fetch(`${API_BASE}/health`);
    const data = await res.json();
    console.log('✅ API Health:', data);
    return data;
  } catch (error) {
    console.error('❌ Health check failed:', error);
  }
};

console.log('✅ TestPayment.js loaded');
export default runTestPayment;